import { Injectable, inject } from '@angular/core';
import {
  DetectionService,
  RenderService,
  SimulationService,
  TaskService,
} from '@services';
import '@tensorflow/tfjs-backend-webgl';
import { ObjectoMetricsService } from './objecto-metrics.service';
import { SharedService } from './shared.service';

const WORKERS = {
  cycleWorker: {
    id: 'cycleWorker',
    model: 'default',
    historySize: 20,
    confidence: 0.2,
  },
  boardWorker: {
    id: 'boardWorker',
    model: 'board',
    historySize: 20,
    confidence: 0.2,
  },
};

@Injectable({
  providedIn: 'root',
})
export class ObjectoService {
  private detectionService = inject(DetectionService);
  private objectoMetricsService = inject(ObjectoMetricsService);
  private renderService = inject(RenderService);
  private shared = inject(SharedService);
  private simulationService = inject(SimulationService);
  private taskService = inject(TaskService);

  constructor() {
    this.detectionService.addWorkers(WORKERS);
    this.shared.cycleWorkerId = WORKERS.cycleWorker.id;
    this.shared.boardWorkerId = WORKERS.boardWorker.id;
  }

  async runDetection() {
    if (this.simulationService.isSimulationRunning()) {
      await this.detectionService.detect(WORKERS.cycleWorker.id);
      await this.detectionService.detect(WORKERS.boardWorker.id);
      if (this.simulationService.state() === 'simulation') {
        this.shared.toolTracking();
        this.shared.runHeatMapMetrics();
        switch (this.taskService.currentTaskId()) {
          case 'transfer': {
            this.shared.placeRight().then(async (allTrianglesPlaced) => {
              if (allTrianglesPlaced) {
                await new Promise((resolve) => setTimeout(resolve, 3000));
                this.renderService.clearStaticOverlays();
                await this.taskService.completeTask('transfer');
              }
            });
            break;
          }
          case 'transferBack': {
            if (!this.taskService.taskListCompleted()) {
              this.shared.placeLeft().then(async (allTrianglesPlaced) => {
                if (allTrianglesPlaced) {
                  await new Promise((resolve) => setTimeout(resolve, 3000));
                  await this.taskService.completeTask('transferBack');
                }
              });
            }
            break;
          }
        }
      }
    }
  }

  stopDetection() {
    this.objectoMetricsService.finalizeMetrics();
    this.detectionService.terminateAllworkers();
  }
}
